/**
 * Which stored floor plan paths this venue is actually allowed to show.
 *
 * `floorPlanImages` is an array of Storage paths written by an admin, so it is
 * the one venue field that can name a file belonging to something else. Both
 * sides need the same answer — the participant gallery fetches these, and the
 * admin dialog lists and removes them — and the backend enforces it a third
 * time when DELETE_VENUE sweeps the blobs, refusing a venue whose array holds
 * an external or nested path.
 *
 * Its own module rather than a component export, so the admin side can import
 * it without dragging the participant venue page into an admin unit test.
 */
export function ownedFloorPlanPaths(
  eventId: string,
  venueId: string,
  paths: string[],
): string[] {
  const prefix = `events/${eventId}/venues/${venueId}/`;
  return paths.filter((path) => {
    if (!path.startsWith(prefix)) return false;
    const file = path.slice(prefix.length);
    return file.length > 0 && !file.includes("/");
  });
}
